import { useState } from "react";
import dayjs from "dayjs";
import { useGetStudiesQuery } from "../../api/useGetStudies";
import {
  Button,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  FormControl,
  InputLabel,
  Alert,
} from "@mui/material";
import StudyDialog from "./components/StudyDialog";
import { SUBJECT } from "../../common/constants/subject";

const AdminStudyPage = () => {
  const [page, setPage] = useState(1);
  const [category, setCategory] = useState("all");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading, error } = useGetStudiesQuery({ page, category });
  const [editData, setEditData] = useState(null);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    setPage(1); // 카테고리 변경 시 페이지를 초기화
  };
  const handleEditClick = (study) => {
    setEditData(study);
    openModal();
  };

  const handleNewItem = () => {
    setEditData(null);
    openModal();
  };

  if (isLoading) {
    return <h2>Loading...</h2>;
  }
  if (error) {
    return <Alert severity="error">에러...</Alert>;
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8} lg={6}>
        <FormControl fullWidth>
          <InputLabel>카테고리</InputLabel>
          <Select
            value={category}
            label="카테고리"
            onChange={handleCategoryChange}
          >
            <MenuItem value="all">All</MenuItem>
            {SUBJECT.map((subject) => (
              <MenuItem value={subject.value}>{subject.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleNewItem}
          sx={{ mb: 2 }}
        >
          새 스터디 만들기
        </Button>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>제목</TableCell>
              <TableCell>카테고리</TableCell>
              <TableCell>시즌</TableCell>
              <TableCell>시작일</TableCell>
              <TableCell>종료일</TableCell>
              <TableCell>수정/삭제</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((study) => (
              <TableRow key={study.id}>
                <TableCell>{study.title}</TableCell>
                <TableCell>{study.category}</TableCell>
                <TableCell>{study.season}</TableCell>
                <TableCell>
                  {dayjs(study.startDate).format("YYYY-MM-DD")}
                </TableCell>
                <TableCell>
                  {dayjs(study.endDate).format("YYYY-MM-DD")}
                </TableCell>
                <TableCell>
                  <Button onClick={() => handleEditClick(study)}>Edit</Button>
                  <Button>Delete</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Pagination
          count={data?.totalPages}
          page={page}
          onChange={(event, value) => setPage(value)}
          color="primary"
          sx={{ mt: 2, display: "flex", justifyContent: "center" }}
        />
        <StudyDialog
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          editMode={!!editData}
          initialData={editData}
        />
      </Grid>
    </Grid>
  );
};

export default AdminStudyPage;
